"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spaceXXSmall = exports.spaceXXLarge = exports.spaceXSmall = exports.spaceXLarge = exports.spaceSmall = exports.spaceNone = exports.spaceNegHalfFluid = exports.spaceNegFluid = exports.spaceMedium = exports.spaceLarge = exports.spaceHalfFluid = exports.spaceFluid = void 0;
const spaceNone = exports.spaceNone = '0px';
const spaceXXSmall = exports.spaceXXSmall = '4px';
const spaceXSmall = exports.spaceXSmall = '8px';
const spaceSmall = exports.spaceSmall = '12px';
const spaceMedium = exports.spaceMedium = '20px';
const spaceLarge = exports.spaceLarge = '32px';
const spaceXLarge = exports.spaceXLarge = '52px';
const spaceXXLarge = exports.spaceXXLarge = '84px';
const spaceFluid = exports.spaceFluid = '100%';
const spaceNegFluid = exports.spaceNegFluid = '-100%';
const spaceHalfFluid = exports.spaceHalfFluid = '50%';
const spaceNegHalfFluid = exports.spaceNegHalfFluid = '-50%';